import axios from "@/api/axiosInstance";

export function createContact(payload) {
  return axios.post(`/api/v1/contacts`, payload);
}

export function fetchContacts(pageNumber) {
  return axios.get(`/api/v1/contacts?page=${pageNumber}`);
}

export function updateContact(payload) {
  return axios.patch(`/api/v1/contacts/${payload.id}`, payload.values);
}

export function deleteContact(payload) {
  return axios.delete(`/api/v1/contacts/${payload}`);
}

export function fetchContactsBulk(pageNumber) {
  return axios.get(`/api/v1/contacts?page=${pageNumber}&limit=1000`);
}
